export default __webpack_public_path__ + "static/media/mixed-gas-banner.5793aaf4.jpg";